/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header{background-color:#fff}.hx-rrbox-noctural{background-color:#183f66}.hx-rrbox-noctural .metric-box-value{color:#fff}.hx-rrbox-noctural .metric-box-range .metric-box-body{background-color:#183f66;opacity:.9;color:#fff}.daterangepicker{border:0 solid #fff;font-size:14px;padding-left:5px;padding-top:2px;cursor:pointer}"];
export { styles as styles };
